import { useSelector } from 'react-redux'
import { getCookie, Cookies } from '../utils/cookies'
import { userRoleSelector } from '../state/user/selectors'

const useUserRole = (): string | null => {
  const cookieUserRole = getCookie(Cookies.UserRole)
  const storeUserRole = useSelector(userRoleSelector)
  const userRole = storeUserRole || cookieUserRole || null
  return userRole
}

export default useUserRole
